"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Graffiti = function Graffiti(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M10 4.5C10.2761 4.5 10.5 4.27614 10.5 4C10.5 3.72386 10.2761 3.5 10 3.5C9.72386 3.5 9.5 3.72386 9.5 4C9.5 4.27614 9.72386 4.5 10 4.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 2.5C12.2761 2.5 12.5 2.27614 12.5 2C12.5 1.72386 12.2761 1.5 12 1.5C11.7239 1.5 11.5 1.72386 11.5 2C11.5 2.27614 11.7239 2.5 12 2.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M14 2.5C14.2761 2.5 14.5 2.27614 14.5 2C14.5 1.72386 14.2761 1.5 14 1.5C13.7239 1.5 13.5 1.72386 13.5 2C13.5 2.27614 13.7239 2.5 14 2.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M18 2.5C18.2761 2.5 18.5 2.27614 18.5 2C18.5 1.72386 18.2761 1.5 18 1.5C17.7239 1.5 17.5 1.72386 17.5 2C17.5 2.27614 17.7239 2.5 18 2.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M10 2.5C10.2761 2.5 10.5 2.27614 10.5 2C10.5 1.72386 10.2761 1.5 10 1.5C9.72386 1.5 9.5 1.72386 9.5 2C9.5 2.27614 9.72386 2.5 10 2.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M8 2.5C8.27614 2.5 8.5 2.27614 8.5 2C8.5 1.72386 8.27614 1.5 8 1.5C7.72386 1.5 7.5 1.72386 7.5 2C7.5 2.27614 7.72386 2.5 8 2.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M16 4.5C16.2761 4.5 16.5 4.27614 16.5 4C16.5 3.72386 16.2761 3.5 16 3.5C15.7239 3.5 15.5 3.72386 15.5 4C15.5 4.27614 15.7239 4.5 16 4.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M16 2.5C16.2761 2.5 16.5 2.27614 16.5 2C16.5 1.72386 16.2761 1.5 16 1.5C15.7239 1.5 15.5 1.72386 15.5 2C15.5 2.27614 15.7239 2.5 16 2.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M14 6.5C14.2761 6.5 14.5 6.27614 14.5 6C14.5 5.72386 14.2761 5.5 14 5.5C13.7239 5.5 13.5 5.72386 13.5 6C13.5 6.27614 13.7239 6.5 14 6.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 6.5C12.2761 6.5 12.5 6.27614 12.5 6C12.5 5.72386 12.2761 5.5 12 5.5C11.7239 5.5 11.5 5.72386 11.5 6C11.5 6.27614 11.7239 6.5 12 6.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M8 4.5C8.27614 4.5 8.5 4.27614 8.5 4C8.5 3.72386 8.27614 3.5 8 3.5C7.72386 3.5 7.5 3.72386 7.5 4C7.5 4.27614 7.72386 4.5 8 4.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M6 2.5C6.27614 2.5 6.5 2.27614 6.5 2C6.5 1.72386 6.27614 1.5 6 1.5C5.72386 1.5 5.5 1.72386 5.5 2C5.5 2.27614 5.72386 2.5 6 2.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M10 6.5C10.2761 6.5 10.5 6.27614 10.5 6C10.5 5.72386 10.2761 5.5 10 5.5C9.72386 5.5 9.5 5.72386 9.5 6C9.5 6.27614 9.72386 6.5 10 6.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 4.5C12.2761 4.5 12.5 4.27614 12.5 4C12.5 3.72386 12.2761 3.5 12 3.5C11.7239 3.5 11.5 3.72386 11.5 4C11.5 4.27614 11.7239 4.5 12 4.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M14 4.5C14.2761 4.5 14.5 4.27614 14.5 4C14.5 3.72386 14.2761 3.5 14 3.5C13.7239 3.5 13.5 3.72386 13.5 4C13.5 4.27614 13.7239 4.5 14 4.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M9 5.5C9.27614 5.5 9.5 5.27614 9.5 5C9.5 4.72386 9.27614 4.5 9 4.5C8.72386 4.5 8.5 4.72386 8.5 5C8.5 5.27614 8.72386 5.5 9 5.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M9 1.5C9.27614 1.5 9.5 1.27614 9.5 1C9.5 0.723858 9.27614 0.5 9 0.5C8.72386 0.5 8.5 0.723858 8.5 1C8.5 1.27614 8.72386 1.5 9 1.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M11 1.5C11.2761 1.5 11.5 1.27614 11.5 1C11.5 0.723858 11.2761 0.5 11 0.5C10.7239 0.5 10.5 0.723858 10.5 1C10.5 1.27614 10.7239 1.5 11 1.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M13 1.5C13.2761 1.5 13.5 1.27614 13.5 1C13.5 0.723858 13.2761 0.5 13 0.5C12.7239 0.5 12.5 0.723858 12.5 1C12.5 1.27614 12.7239 1.5 13 1.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M15 1.5C15.2761 1.5 15.5 1.27614 15.5 1C15.5 0.723858 15.2761 0.5 15 0.5C14.7239 0.5 14.5 0.723858 14.5 1C14.5 1.27614 14.7239 1.5 15 1.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M17 1.5C17.2761 1.5 17.5 1.27614 17.5 1C17.5 0.723858 17.2761 0.5 17 0.5C16.7239 0.5 16.5 0.723858 16.5 1C16.5 1.27614 16.7239 1.5 17 1.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M19 1.5C19.2761 1.5 19.5 1.27614 19.5 1C19.5 0.723858 19.2761 0.5 19 0.5C18.7239 0.5 18.5 0.723858 18.5 1C18.5 1.27614 18.7239 1.5 19 1.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M11 3.5C11.2761 3.5 11.5 3.27614 11.5 3C11.5 2.72386 11.2761 2.5 11 2.5C10.7239 2.5 10.5 2.72386 10.5 3C10.5 3.27614 10.7239 3.5 11 3.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M13 3.5C13.2761 3.5 13.5 3.27614 13.5 3C13.5 2.72386 13.2761 2.5 13 2.5C12.7239 2.5 12.5 2.72386 12.5 3C12.5 3.27614 12.7239 3.5 13 3.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M17 3.5C17.2761 3.5 17.5 3.27614 17.5 3C17.5 2.72386 17.2761 2.5 17 2.5C16.7239 2.5 16.5 2.72386 16.5 3C16.5 3.27614 16.7239 3.5 17 3.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M7 1.5C7.27614 1.5 7.5 1.27614 7.5 1C7.5 0.723858 7.27614 0.5 7 0.5C6.72386 0.5 6.5 0.723858 6.5 1C6.5 1.27614 6.72386 1.5 7 1.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M5 1.5C5.27614 1.5 5.5 1.27614 5.5 1C5.5 0.723858 5.27614 0.5 5 0.5C4.72386 0.5 4.5 0.723858 4.5 1C4.5 1.27614 4.72386 1.5 5 1.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M9 3.5C9.27614 3.5 9.5 3.27614 9.5 3C9.5 2.72386 9.27614 2.5 9 2.5C8.72386 2.5 8.5 2.72386 8.5 3C8.5 3.27614 8.72386 3.5 9 3.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M7 3.5C7.27614 3.5 7.5 3.27614 7.5 3C7.5 2.72386 7.27614 2.5 7 2.5C6.72386 2.5 6.5 2.72386 6.5 3C6.5 3.27614 6.72386 3.5 7 3.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M15 5.5C15.2761 5.5 15.5 5.27614 15.5 5C15.5 4.72386 15.2761 4.5 15 4.5C14.7239 4.5 14.5 4.72386 14.5 5C14.5 5.27614 14.7239 5.5 15 5.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M15 3.5C15.2761 3.5 15.5 3.27614 15.5 3C15.5 2.72386 15.2761 2.5 15 2.5C14.7239 2.5 14.5 2.72386 14.5 3C14.5 3.27614 14.7239 3.5 15 3.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M13 7.5C13.2761 7.5 13.5 7.27614 13.5 7C13.5 6.72386 13.2761 6.5 13 6.5C12.7239 6.5 12.5 6.72386 12.5 7C12.5 7.27614 12.7239 7.5 13 7.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M11 7.5C11.2761 7.5 11.5 7.27614 11.5 7C11.5 6.72386 11.2761 6.5 11 6.5C10.7239 6.5 10.5 6.72386 10.5 7C10.5 7.27614 10.7239 7.5 11 7.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M11 5.5C11.2761 5.5 11.5 5.27614 11.5 5C11.5 4.72386 11.2761 4.5 11 4.5C10.7239 4.5 10.5 4.72386 10.5 5C10.5 5.27614 10.7239 5.5 11 5.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M13 5.5C13.2761 5.5 13.5 5.27614 13.5 5C13.5 4.72386 13.2761 4.5 13 4.5C12.7239 4.5 12.5 4.72386 12.5 5C12.5 5.27614 12.7239 5.5 13 5.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12.5 8.53589V8C12.5 7.86739 12.4473 7.74021 12.3536 7.64645C12.2598 7.55268 12.1326 7.5 12 7.5C11.8674 7.5 11.7402 7.55268 11.6464 7.64645C11.5527 7.74021 11.5 7.86739 11.5 8V8.53589C9.80611 8.77925 8.5 10.2399 8.5 12V18C8.5 18.9283 8.86875 19.8185 9.52513 20.4749C10.1815 21.1313 11.0717 21.5 12 21.5C12.9283 21.5 13.8185 21.1313 14.4749 20.4749C15.1313 19.8185 15.5 18.9283 15.5 18V12C15.5 10.2399 14.1939 8.77925 12.5 8.53589ZM14.5 18C14.5 18.663 14.2366 19.2989 13.7678 19.7678C13.2989 20.2366 12.663 20.5 12 20.5C11.337 20.5 10.7011 20.2366 10.2322 19.7678C9.76339 19.2989 9.5 18.663 9.5 18V14.4468C9.82544 14.7802 10.2143 15.0451 10.6436 15.226C11.0729 15.4068 11.5341 15.5 12 15.5C12.4659 15.5 12.9271 15.4068 13.3564 15.226C13.7857 15.0451 14.1746 14.7802 14.5 14.4468V18ZM14.5 12C14.5 12.663 14.2366 13.2989 13.7678 13.7678C13.2989 14.2366 12.663 14.5 12 14.5C11.337 14.5 10.7011 14.2366 10.2322 13.7678C9.76339 13.2989 9.5 12.663 9.5 12C9.50075 11.4239 9.70008 10.8657 10.0644 10.4195C10.4287 9.97328 10.9357 9.6663 11.5 9.55031V10C11.5 10.1326 11.5527 10.2598 11.6464 10.3536C11.7402 10.4473 11.8674 10.5 12 10.5C12.1326 10.5 12.2598 10.4473 12.3536 10.3536C12.4473 10.2598 12.5 10.1326 12.5 10V9.55031C13.0643 9.6663 13.5713 9.97328 13.9356 10.4195C14.2999 10.8657 14.4993 11.4239 14.5 12Z",
    fill: props.foregroundColor
  }));
};

Graffiti.defaultProps = {
  altText: "Graffiti",
  backgroundColor: "#00D2D2",
  foregroundColor: "#000000"
};
Graffiti.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Graffiti;
exports.default = _default;